import { Nullable } from "@core/domain/types/nullable.type";
import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { EntityApiKeysRepository } from "@entity-api-keys/data/repositories/entity-api-keys.repository";
import { EntityApiKey } from "@entity-api-keys/domain/models/entity-api-key.model";
import { UpdateEntityApiKey } from "@entity-api-keys/domain/models/update-entity-api-key.model";
import { getEntityApiKeyToastErrorMessage } from "@entity-api-keys/domain/utils/entity-api-key-toast-error-message";
import { inject, injectable } from "inversify";

@injectable()
export class UpdateEntityApiKeyUseCase {
    constructor(
        @inject(EntityApiKeysRepository)
        private readonly repository: EntityApiKeysRepository,
    ) {}

    async execute(model: UpdateEntityApiKey): Promise<Nullable<EntityApiKey>> {
        const result = await this.repository.update(model);

        if (result.isLeft()) {
            ToastManagerStore.error(
                getEntityApiKeyToastErrorMessage(result.getLeftOrThrow()),
            );
        }

        return result.fold(
            () => null,
            (updated) => updated,
        );
    }
}
